import React from "react";

const Mentors = () => {
  return (
    <svg viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="29" cy="30.5" r="19.5" fill="url(#paint0_linear_3991_129)" />
      <path
        d="M33.7986 46.648C33.6394 46.3958 33.5598 46.2697 33.5153 46.0752C33.4818 45.9291 33.4818 45.6988 33.5153 45.5527C33.5598 45.3582 33.6394 45.2321 33.7986 44.9799C35.1138 42.896 39.0289 37.6279 44.9951 37.6279C50.9613 37.6279 54.8763 42.896 56.1916 44.9799C56.3508 45.2321 56.4304 45.3582 56.4749 45.5527C56.5084 45.6988 56.5084 45.9291 56.4749 46.0752C56.4304 46.2697 56.3508 46.3958 56.1916 46.648C54.8763 48.7319 50.9613 54 44.9951 54C39.0289 54 35.1138 48.7319 33.7986 46.648Z"
        fill="url(#paint1_linear_3991_129)"
      />
      <path
        d="M45 48.9C46.6569 48.9 48 47.5569 48 45.9C48 44.2431 46.6569 42.9 45 42.9C43.3431 42.9 42 44.2431 42 45.9C42 47.5569 43.3431 48.9 45 48.9Z"
        fill="url(#paint2_linear_3991_129)"
      />
      <path
        d="M49.3743 31.5904C49.3944 31.2179 49.4047 30.8427 49.4047 30.4651C49.4047 19.1625 40.2478 10 28.9523 10C17.6568 10 8.5 19.1625 8.5 30.4651C8.5 41.5887 17.3692 50.6396 28.4175 50.9234M28.9523 18.186V30.4651L35.088 33.5349M44.9951 37.6279C39.0289 37.6279 35.1138 42.896 33.7986 44.9799C33.6394 45.2321 33.5598 45.3582 33.5153 45.5527C33.4818 45.6988 33.4818 45.9291 33.5153 46.0752C33.5598 46.2697 33.6394 46.3958 33.7986 46.648C35.1138 48.7319 39.0289 54 44.9951 54C50.9613 54 54.8763 48.7319 56.1916 46.648C56.3508 46.3958 56.4304 46.2697 56.4749 46.0752C56.5084 45.9291 56.5084 45.6988 56.4749 45.5527C56.4304 45.3582 56.3508 45.2321 56.1916 44.9799C54.8763 42.896 50.9613 37.6279 44.9951 37.6279ZM48 45.9C48 47.5569 46.6569 48.9 45 48.9C43.3431 48.9 42 47.5569 42 45.9C42 44.2431 43.3431 42.9 45 42.9C46.6569 42.9 48 44.2431 48 45.9Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3991_129"
          x1="49.3357"
          y1="50"
          x2="5.86356"
          y2="45.4052"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5E30BF" />
          <stop offset="1" stopColor="#AF30BF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3991_129"
          x1="57.5286"
          y1="54"
          x2="4.13651"
          y2="47.8437"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5E30BF" />
          <stop offset="1" stopColor="#AF30BF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3991_129"
          x1="57.5286"
          y1="54"
          x2="4.13651"
          y2="47.8437"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5E30BF" />
          <stop offset="1" stopColor="#AF30BF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Mentors;
